module.exports = "<div class=\"pic\" id=\"pic\"></div>\n";